import React from 'react';
import Skeleton from 'react-loading-skeleton';
import '../../pages/Feed/styles.scss';

const SkeletonCard2 = () => {
  return (
    <div className="profiles-container">
      <div className="profile-container">
        <div className="profile-img-container">
          <Skeleton
            height="30vw"
            style={{
              display: 'block',
            }}
          />
        </div>
        <div className="profile-description-container">
          <Skeleton />
          <div className="profile-line-1">
            <h2 className="profile-header">
              <Skeleton />
            </h2>
          </div>
          <h2 className="profile-subheader">
            <Skeleton />
          </h2>
          <p>
            <Skeleton />
          </p>
        </div>
      </div>
      <div className="profile-container">
        <div className="profile-img-container">
          <Skeleton
            height="30vw"
            style={{
              display: 'block',
            }}
          />
        </div>
        <div className="profile-description-container">
          <Skeleton />
          <div className="profile-line-1">
            <h2 className="profile-header">
              <Skeleton />
            </h2>
          </div>
          <h2 className="profile-subheader">
            <Skeleton />
          </h2>
          <p>
            <Skeleton />
          </p>
        </div>
      </div>
      <div className="profile-container">
        <div className="profile-img-container">
          <Skeleton
            height="30vw"
            style={{
              display: 'block',
            }}
          />
        </div>
        <div className="profile-description-container">
          <Skeleton />
          <div className="profile-line-1">
            <h2 className="profile-header">
              <Skeleton />
            </h2>
          </div>
          <h2 className="profile-subheader">
            <Skeleton />
          </h2>
          <p>
            <Skeleton />
          </p>
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard2;
